import ApiService from "./api.service";
import axios from "axios";

// Constant
const baseUrl = 'model/'

const ModelService = {
    /**
	 * Retrieve all model from all engines/frameworks 
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	retrieveModelList(params) {
		return ApiService.get(baseUrl, params);
	},
	/**
	 * Retrieve presigned url for uploading file
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	retrievePresignUrlPost(params) {
		return ApiService.get(baseUrl + 'upload/s3', params);
	},
	/**
	 * Download model to server
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	downloadToServer(params) {
		return ApiService.get(baseUrl + 'download/s3', params);
	},
	/**
	 * Upload file to url   
	 * @param {string} url 
	 * @param {BinaryData} file 
	 * @param {string} fileType 
	 * @returns {Response} response
	 */
	upload(url, content) {
		return axios.post(url, content);
	},
	getSharedModelUser(params) {
		return ApiService.get(baseUrl + 'share', params);
	},
	deleteSharedModel(params) {
		return ApiService.delete(baseUrl + 'share', params);
	},
	share({ body, allowShareData }) {
		return ApiService.post(baseUrl + 'share'+`?allowShareData=${allowShareData}`, body);
	},
	answerSharingRequest(body) {
		return ApiService.post(baseUrl + 'answer', body);
	},
	/**
	 * Upload file to url
	 * @param {string} url
	 * @param {BinaryData} file
	 * @param {string} fileType
	 * @returns {Response} response
	 */
	delete({ username, model_name, model_id }) {
		return ApiService.delete(baseUrl, { username, model_name, model_id });
	},
	/**
	 * Add model default  
	 */
	addModelDefault(params){
		return ApiService.post(baseUrl + 'add', params);
	},
	/**
	 * get model opt from model id
	 * @param {*} modelId model id 
	 * @returns 
	 */
	getModelOptions(modelId) {
		return ApiService.get(baseUrl + `opt/${modelId}`);
	},
	updateModelOptions(modelId, data) {
		return ApiService.put(baseUrl +  `opt/${modelId}`, data)
	},
	updateReferenceImage(modelId, data) {
		return ApiService.post(baseUrl + `reference/image/${modelId}`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
	},
	/**
	 * API for Prompt suggestion feature
	 * @param {str} modelId model id
	 * @param {FormData} data the form data which contain key `image` and `gt_cnt`
	 * @returns 
	 */
	suggestPrompt(modelId, data) {
		return ApiService.post(baseUrl + `suggest_prompt/${modelId}`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
	},
	/**
	 * Get list model for personal model management
	 * @param {dict} param0 The parameters dictionary contains username and page
	 * @returns 
	 */
	getListModel({
		username,
		page = 1,
		limit = 10
	}) {
		return ApiService.get(
			baseUrl + 'query'+
				`?username=${username}&page=${page}&limit=${limit}`
		);
	},

	renameModel(modelId, data) {
		return ApiService.put(baseUrl +  `rename/${modelId}`, data)
	},

	/**
	 * Revert options of model
	 * @param {string} modelId model id
	 * @returns 
	 */
	revertModelOptions(modelId) {
		return ApiService.put(baseUrl + `${modelId}/opt/revert`)
	}
};

export default ModelService;
